var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"workshop-layout"},[_c('layout-header',{staticClass:"all-info",attrs:{"type":"workshop"}}),_c('div',{staticClass:"container"},[_vm._t("default")],2),_c('layout-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }